import { UserTypeBackendStr } from 'src/app/models/user/user-type';
import { Component } from '@angular/core';

@Component({
  selector: 'app-tutors',
  templateUrl: './tutors.component.html',
  styleUrls: ['./tutors.component.scss'],
})
export class TutorsComponent {
  type: string = UserTypeBackendStr.TUTOR;
}
